<template lang="pug">
  .inicio-panel-content.panel-vivemas
    .landing.landing-vivemas
      section
        PopupNotification(:api="apiNot" :query="parametros" v-if="loadPopup")
      section
        div
          v-container
            Banner.beneficios-vm__section
      section.beneficios-vm__section
        div.beneficios_vm__section__filters
          v-container.beneficios_vm__filters__categories
            .landing-detail-nav.justify-md-center
              div.container-category(v-for="category in categories"  @click="goToPath(category.name);gtmChangeCategory(category.name)")
                article(:class="(stringToLowerCase(category.name) == stringToLowerCase(queryVivemas.category))?'selected-box':''")
                  div
                    img(:src="stringToLowerCase(category.name) == stringToLowerCase(queryVivemas.category) ? category.img_hover : category.img" width="32" :alt="'image '+queryVivemas.category")
                  p {{category.name}}
                p.mobile {{category.name}}
          hr.d-md-none
          v-container.pb-0.beneficios_vm__filters__search
            div.d-flex.justify-space-between.align-center.pt-2
              h4 {{ pageTitle }}
              div
                // Icon Ordenar
                svg.d-lg-none.c-pointer(width="24" height="24" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg" @click="openPopupOrdenar = true")
                  path(:fill="[queryVivemas.sortBy  ? '#0855c4' : '#919191']" d="M22.125 2.875H1.875C1.57663 2.875 1.29048 2.75647 1.0795 2.5455C0.868526 2.33452 0.75 2.04837 0.75 1.75C0.75 1.45163 0.868526 1.16548 1.0795 0.954505C1.29048 0.743526 1.57663 0.625 1.875 0.625H22.125C22.4234 0.625 22.7095 0.743526 22.9205 0.954505C23.1315 1.16548 23.25 1.45163 23.25 1.75C23.25 2.04837 23.1315 2.33452 22.9205 2.5455C22.7095 2.75647 22.4234 2.875 22.125 2.875ZM18.375 8.125H5.625C5.32663 8.125 5.04048 8.00647 4.8295 7.79549C4.61853 7.58452 4.5 7.29837 4.5 7C4.5 6.70163 4.61853 6.41548 4.8295 6.2045C5.04048 5.99353 5.32663 5.875 5.625 5.875H18.375C18.6734 5.875 18.9595 5.99353 19.1705 6.2045C19.3815 6.41548 19.5 6.70163 19.5 7C19.5 7.29837 19.3815 7.58452 19.1705 7.79549C18.9595 8.00647 18.6734 8.125 18.375 8.125ZM13.875 13.375H10.125C9.82663 13.375 9.54048 13.2565 9.3295 13.0455C9.11853 12.8345 9 12.5484 9 12.25C9 11.9516 9.11853 11.6655 9.3295 11.4545C9.54048 11.2435 9.82663 11.125 10.125 11.125H13.875C14.1734 11.125 14.4595 11.2435 14.6705 11.4545C14.8815 11.6655 15 11.9516 15 12.25C15 12.5484 14.8815 12.8345 14.6705 13.0455C14.4595 13.2565 14.1734 13.375 13.875 13.375Z" )
                span &nbsp;&nbsp;
                // Icon Filter
                svg.d-lg-none.c-pointer(width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' @click="openPopupFilter = true")
                  path(d='M5 6.03704C5 6.03704 7.07407 5 12.2593 5C17.4444 5 19.5185 6.03704 19.5185 6.03704L13.8148 12.7778V17.4444L10.7037 19V12.7778L5 6.03704Z' :stroke="[queryVivemas.product || queryVivemas.city  ? '#0855c4' : '#919191']" stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
              // Icon Searching
              //- .landing-search.search-benefits.d-none.d-lg-flex
                svg(width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg")
                  path(d="M28.5435 28.5442C28.4783 28.6094 28.401 28.661 28.3159 28.6963C28.2308 28.7315 28.1396 28.7497 28.0475 28.7497C27.9554 28.7497 27.8642 28.7315 27.7791 28.6963C27.694 28.661 27.6167 28.6094 27.5516 28.5442L22.3454 23.3382C20.2881 25.1376 17.612 26.0671 14.8822 25.9302C12.1524 25.7933 9.58269 24.6009 7.7157 22.6047C5.84871 20.6085 4.83063 17.9648 4.87648 15.232C4.92233 12.4992 6.02852 9.89114 7.96142 7.95869C9.89432 6.02624 12.5026 4.92067 15.2355 4.87547C17.9683 4.83026 20.6117 5.84896 22.6075 7.71642C24.6033 9.58388 25.7951 12.1539 25.9313 14.8837C26.0675 17.6135 25.1374 20.2894 23.3375 22.3463L28.5435 27.5523C28.6086 27.6174 28.6603 27.6947 28.6956 27.7798C28.7309 27.865 28.749 27.9562 28.749 28.0483C28.749 28.1404 28.7309 28.2317 28.6956 28.3168C28.6603 28.4019 28.6086 28.4791 28.5435 28.5442ZM15.422 24.5409C17.2256 24.5409 18.9886 24.0061 20.4882 23.0041C21.9878 22.0021 23.1566 20.5779 23.8468 18.9117C24.537 17.2454 24.7176 15.4119 24.3657 13.643C24.0139 11.8741 23.1454 10.2492 21.8701 8.97394C20.5948 7.69863 18.9699 6.83014 17.201 6.47828C15.4321 6.12643 13.5986 6.30701 11.9324 6.9972C10.2661 7.68739 8.84192 8.85619 7.83992 10.3558C6.83792 11.8554 6.30311 13.6184 6.30311 15.422C6.30583 17.8396 7.26745 20.1575 8.97699 21.867C10.6865 23.5766 13.0044 24.5382 15.422 24.5409Z" fill="#0855C4")
                input(type="text" placeholder="Busca lo que necesites" v-on:keyup="filterData($event, (queryVivemas.category === '')?'Beneficios':queryVivemas.category)" v-model="queryVivemas.search")
          
        div.beneficios-vm__section__cards
          v-container.beneficios_vm__filters__benefits
            .d-flex
              .content.d-none.d-lg-block.mt-4
                div.beneficios_vm__benefits__box
                  h3 Ordenar por
                  section
                    .content
                      .d-flex.justify-space-between.mt-2
                        v-radio-group(v-model="temporalOrderBy"  @click="clickOrderByBenefit(temporalOrderBy)")
                          v-radio(:label="ordenar.name"  :value="ordenar.id" v-for="(ordenar, i) in arrayOrdenar" :key="i" )
                  h3.mt-3 Filtrar por
                  section(v-for='(section, index) in stepComponents' :key='index' )
                    .d-flex.justify-space-between.mt-2(@click="selectPopup(section.title); section.open=!section.open")
                      h4.pt-4.pb-2(:class="[section.title === detalleActive || section.open ? 'text-primary' : '']") {{ section.title }} 
                      //- img.c-pointer(src="https://storage.googleapis.com/vivemas/benefits/icons/icon_arrow_up.svg" v-if="section.open")
                      //- img.c-pointer(src="https://storage.googleapis.com/vivemas/benefits/icons/icon_arrow_down.svg" v-else)
                    .content
                      div
                        v-radio-group(v-model="temporalCity" @click="setFilters('city', temporalCity, true)")
                          v-radio(:label="city.name"  :value="city.name" v-for="(city, i) in arrCitiesData" :key="i" )
                        hr.mx-3
              CardsPromotion(:api="api" :query="parametros" :saveGTM="switchAction" :origin="originCards" v-if="loaded")
      //- section
        v-container
          h2 {{(categoryTitle === '')?'Beneficios':categoryTitle}}
          div 
            CardsPromotion(:api="api" :query="parametros" :saveGTM="switchAction" :origin="'ZonaSegura'" v-if="loaded")
      v-bottom-sheet.d-lg-none.modal-filters( v-model="openPopupOrdenar" )
        v-card.modal-filters__box
          v-card-actions.text-right.d-block.px-0
            div.d-flex.justify-space-between.px-2
              h3 Ordenar por
              svg.cursor-pointer(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click='openPopupOrdenar=false')
                path(d="M18 6L6 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                path(d="M6 6L18 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
            .content.mt-lg-5.modal-filters__orderBy
              section.modal-filters__box__section
                .d-flex.justify-space-between.mt-2
                  v-radio-group(v-model="temporalOrderBy" @click="clickOrderByBenefit(temporalOrderBy)")
                    v-radio(:label="ordenar.name"  :value="ordenar.id" v-for="(ordenar, i) in arrayOrdenar" :key="i"  )
            
      v-bottom-sheet.d-lg-none.modal-filters( v-model="openPopupFilter" )
        v-card.modal-filters__box
          v-card-actions.text-right.d-block.px-0
            div.d-flex.justify-space-between.px-2
              h3 Filtrar por
              svg.cursor-pointer(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click='openPopupFilter=false')
                path(d="M18 6L6 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                path(d="M6 6L18 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
            .content
              section.modal-filters__box__section(v-for='(section, index) in stepComponents' :key='index' )
                .d-flex.justify-space-between.mt-lg-2(@click="selectPopup(section.title)")
                  h4(:class="[section.title === detalleActive ? 'text-primary' : '']").pt-4.pb-2 {{ section.title }} 
                  //- img.mr-4.c-pointer(style="flex: none!important" :src="section.title === detalleActive ? 'https://storage.googleapis.com/vivemas/benefits/icons/icon_arrow_up.svg' : 'https://storage.googleapis.com/vivemas/benefits/icons/icon_arrow_down.svg'")
                .content
                  div(v-if="index == 0 && section.title === detalleActive")
                    v-radio-group(v-model="queryVivemas.city")
                      v-radio(:label="city.name"  :value="city.name" v-for="(city, i) in arrCitiesData" :key="i" )
                  hr
              div#is-filter-actions
                div#is-filter-action-1.is-filter-actions
                  button(id="is-filter-btn_submit" :class="[queryVivemas.city ? '' : 'disabled']" type="action" transform="none" @click="filterAction()") Filtrar
                div#is-filter-action-2.is-filter-actions
                  button(id="is-filter-btn_clear" :class="[queryVivemas.city ? '' : 'disabled' ]" type="outline" @click="clear()") Cancelar
  </template>
  <script>
  import { mapActions, mapGetters } from 'vuex'
  import Navigation from '@/components/LandingNavig.vue'
  import CardsPromotion from 'is-card-benefit/src/components/CardsPromotion.vue'
  import PopupNotification from '@/components/vivemas/PopupNotification.vue'
  import Banner from '@/components/vivemas/Banner.vue'
  
  import moment from 'moment';
  
  export default{
    components: {
      Navigation,
      PopupNotification,
      CardsPromotion,
      Banner
    },
    data: () => ({
      originCards: process.env.VIVEMAS_ORIGIN,
      apiNot: {
        url: process.env.API_VIVEMAS,
      },
      api: {
        url: process.env.API_VIVEMAS + '/benefits',
      },
      arrayOrdenar: [
        {
          id: 'brand',
          name: 'Marca (A-Z)',
          order: 1
        },
        {
          id: 'benefit_type',
          name: ' Tipo beneficio (A-Z)',
          order: 1
        },
        {
          id: 'stars',
          name: 'Mejor valorados',
          order: -1
        },
        {
          id: 'num_ratings',
          name: 'Más usados',
          order: -1
        },
        {
          id: 'expire',
          name: 'Próximos a vencer',
          order: 1
        },
        {
          id: 'created_at',
          name: 'Novedades',
          order: -1
        }
      ],
      getUrl: process.env.API_VIVEMAS + '/benefits',
      pageTitle: '',
      temporalCity: '',
      temporalOrderBy: '',
      queryVivemas: {
        category: '',
        product: '',
        city: '',
        benefit: '',
        // search: '',
        sortBy: '',
        order: 0,
        id: '',
      },
      parametros: {},
      loaded: false,
      loadPopup: false,
      categories: [],
      categoryTitle: '',
      benefit: '',
      brand: '',
      loader: false,
      loaderText: '',
      callModal: false,
      showService: true,
      showInfo: false,
      detalleActive: 'Ciudad',
      dataBenefits: [],
      skip: 0,
      limit: 12,
      counter: 0,
      stepComponents : ([
        { title: 'Ciudad', open: true }
      ]),
      search: '',
      arrCitiesData: [],
      isOnlySoat: false,
      productsArray: [],
      routeName: 'BenefitsVivemas',
      searchPersistent: '',
      citySelected: {
        name: 'Todos'
      },
      openPopupOrdenar: false,
      openPopupFilter: false,
    }),
    mounted () {
      // Get query parameters from the URL
      const queryParams = this.$route.query;
      // Set the page title based on query parameters
      this.pageTitle = this.generateTitle(queryParams);
      //- this.pageTitle = ''
      this.gtmSend(this.serializeQuery(queryParams))
  
      this.categoryTitle = this.$route.query.category
      this.benefit = this.$route.query.benefit || ''
      if (this.categoryTitle && this.categoryTitle !== '') {
        this.gtmSend(this.categoryTitle)
      } 
      this.dataBenefits = []
      this.getBenefitsCallback()
      this.categories = this.benefitCategories || []
      const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      }
      fetch(process.env.API_VIVEMAS + '/categories/benefits', requestOptions)
        .then(response => response.json())
        .then(data => {
          this.$store.commit('vivemas/setBenefitCategories', data.data)
          this.categories = data.data
        })
        .catch(error => console.error('Error getBenefitsCategories: ',error));
      //- this.getBenefitsCategories().then(res => {
      //-   this.$store.commit('vivemas/setBenefitCategories', res.data.data)
      //-   this.categories = res.data.data
      //- }).catch(err => {
      //- })
      this.cities = this.benefitsCities || []
      fetch(process.env.API_VIVEMAS + '/cities', requestOptions)
        .then(response => response.json())
        .then(data => {
          this.cities = data.data
          this.$store.commit('popupciudad/setBenefitsCities', data.data)
          this.cities.unshift({ id: '', name: 'Todos' })
          return this.cities
        })
        .then(cities => {
          cities.forEach(element => {
            this.arrCitiesData.push(element)
          })
        })
        .catch(error => console.error('Error getBenefitsCategories: ',error));
    },
    methods: {
      ...mapActions('vivemas', ['getBenefitsCategories']),
      ...mapActions('event', ['eventLog']),
      stringToLowerCase (str) {
        let result = str ? str.toLowerCase() : ''
        return result
      },
      setDataTracking (tracking) {
        tracking.push(moment().format('DD/MM/YYYY'))
        tracking.push(this.basicInfo.numeroDocumento)
        
        let data = {"data": [ tracking]}
        fetch(process.env.API_VIVEMAS_TRACKING + '?startCell=a2', {method: 'POST', body: JSON.stringify(data)})
        .then(response => response.json())
        .then(data => {
          // console.log('data: ', data)
        })
        .catch(error => console.error('Error getBenefitsCategories: ',error));
        //- return resp
      },
      switchAction (UAT, GA4) {
        //Register GTM
        this.registerGTM(UAT, GA4)

        const datosEventLog = {
          ...UAT
        }

        //Register Event
        this.eventLog({
          categoria: 'Vivemas',
          nombre: UAT["CTA"],
          datos: datosEventLog
        })
      },
      serializeQuery(params) {
        // Helper function to serialize query parameters
        return Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');
      },
      capitalizeString (str) {
        const capitalize = str.charAt(0).toUpperCase() + str.slice(1);
        return capitalize
      },
      generateTitle(queryParams) {
        const { category, product, city, benefit, sortBy, order, id } = queryParams
        if (category) { this.queryVivemas.category = category ? category : 'Todas categorías' }
        if (city) { this.queryVivemas.city = city; this.temporalCity = city }
        // if (search) { this.queryVivemas.search = search }
        if (benefit) { this.queryVivemas.benefit = benefit }
        if (id) { this.queryVivemas.id = id }
        // Create a title based on query parameters
        // Replace this with your own logic
        let nameSortBy = ''
        if (sortBy) {
          nameSortBy = this.arrayOrdenar.find(x=> sortBy==x.id).name  || ''
          this.queryVivemas.sortBy = sortBy
          this.queryVivemas.order = order
          this.temporalOrderBy = sortBy
        }
        let title = '';
        title += category ? this.capitalizeString(category) : 'Todas las categorías'
        title += city ? ' > ' + this.capitalizeString(city) : ''
        title += sortBy ? ' > ' + this.capitalizeString(nameSortBy) : ''
        return title;
      },
      getBenefitsCallback (loadData) {
        let req = {}
        req.skip = this.skip 
        req.limit = this.limit
        req.numeroDocumento = this.basicInfo.numeroDocumento;
        req.email = this.basicInfo.correo
        // filter to refresh benefits
        if (this.queryVivemas) {
          Object.entries(this.queryVivemas)
          .filter(([key, value]) => {
            req[key] = value
            if (key === 'city' && value == 'Todos') {
              req[key] = ''
            }
          })
        }
        this.parametros = req
        this.loaded = true
        this.loadPopup = true
      },
      selectPopup (title) {
        this.detalleActive = title
      },
      goToHome () {
        this.$router.push('/')
      },
      goToPath (option) {
        // this.queryVivemas.search = ''
        this.queryVivemas.benefit = ''
        this.queryVivemas.category = (option === this.queryVivemas.category) ? '' : option
        let router = { name: this.routeName, query: {} }
        router.query = { category: '' }
        Object.entries(this.queryVivemas)
        .filter(([key, value]) => {
          if (value) { router.query[key] = value || ''}
          else { delete router.query[key] }
        })

        this.getBenefitsCallback()
        // Set the page title based on query parameters
        this.pageTitle = this.generateTitle(router.query || {});
        this.$router.push(router).catch(err => { console.log(err) })
      },
      registerGTM (UAT, GA4) {
        UAT.category = 'Zona Segura'
        GA4['Nombre Sección'] = 'Zona Segura'
        this.$gtm.trackEvent(UAT);
        this.$gtm.trackEvent(GA4);
      },
      
      // EVENT - 51 - Elemento - Cambiar Categorías - ANALYTICS
      gtmChangeCategory (nameCategory) {
        // GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección':  'Zona Segura',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Vive+ - Beneficio',
          'CTA':'Seleccionar categoría - ' + nameCategory
        });
        // UA
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Zona Segura',
          'action': 'Vive+ - Beneficio',
          'label': 'Seleccionar categoría - ' + nameCategory
        });
      },
      gtmBtn (nameCategory) {
        // GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Zona Segura',
          'TipoElemento': 'Ícono- Botón',
          'TipoAccion': 'Vive+ - Beneficio',
          'CTA':'Seleccionar botón - Ver más  - ' + nameCategory
        });
        // UA
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Zona Segura',
          'action': 'Vive+ - Beneficio',
          'label': 'Seleccionar botón - Ver más  - ' + nameCategory
        });
      },
      // filterData (evt, category) {
      //   evt.preventDefault()
      //   this.benefit=''
      //   this.categoryTitle = ''
      //   this.search = evt.target.value
      //   if (evt.key === 'Enter') {
      //     this.gtmSearch(this.search, category)
      //     this.getBenefitsCallback()
      //   }
      // },
      gtmSend (path) {
        let formatPagePath = '/zona-segura/vivemas/beneficios/?category=' + this.removeAcents(path.toLowerCase().split(' y ').join(' ').split(' de ').join(' ')).split(' ').join('-')
        this.$gtm.trackEvent({
          event: 'virtualPage',
          category: 'Zona Segura',
          pageName: path,
          pagePath: formatPagePath
        })
        this.$gtm.trackEvent({
          event: 'virtualPage',
          category: 'Zona Segura',
          pageName: path,
          pagePath: formatPagePath
        })
      },
      // gtmSearch (search, category) {
      //   // GA4
      //   this.$gtm.trackEvent({
      //     'event': 'select_button',
      //     'Nombre Sección':  'Zona Segura',
      //     'TipoElemento': 'Botón',
      //     'TipoAccion': 'Vive+ - Buscador',
      //     'CTA': search,
      //     'Categoría': category
      //   });
      //   // UA
      //   this.$gtm.trackEvent({
      //     'event': 'virtualEvent',
      //     'category': 'Zona Segura',
      //     'action': 'Vive+ - Buscador',
      //     'label': search,
      //     'dimension27' : category
      //   });
      // },
      removeAcents (cadena) {
        const acentos = {'%': '', 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U'}
        return cadena.split('').map(letra => acentos[letra] || letra).join('').toString()
      },
      openPopupMethod () {
        this.openPopup = !this.openPopup
      },
      setFilters (property, valueProperty, auto) {
        this.queryVivemas.benefit = ''
        let router = { name: this.routeName }
        router.query = { city: '' }
        if (auto) {
          this.queryVivemas[property] = valueProperty = (valueProperty == this.queryVivemas[property]) ? '' : valueProperty
          // gtm
          if (!this.queryVivemas.city) { this.temporalCity = '' }
          let nameValue = property == 'city' ? 'Ciudad': property == 'product' ? 'Producto ' : 'Tipo'
          this.gtmFiltraryOrdenar('Filtrar por', 'Seleccionar ' + nameValue, valueProperty)
        }
        //- this.queryVivemas[property] = value = (value == this.queryVivemas[property]) ? '' : value
        Object.entries(this.queryVivemas)
        .filter(([key, value]) => {
          if (value) { router.query[key] = value || ''}
          else { delete router.query[key] }
        })
        this.getBenefitsCallback()
        this.pageTitle = this.generateTitle(router.query);
        this.$router.push(router).catch(err => { console.log(err) })
      },
      clickOrderByBenefit (value) {
        let selectOrder = this.arrayOrdenar.filter((order) => order.id == value)[0]
        this.queryVivemas.benefit = ''
        this.queryVivemas.sortBy = (this.queryVivemas.sortBy != selectOrder.id ) ? selectOrder.id : ''
        this.queryVivemas.order = (this.queryVivemas.sortBy) ? selectOrder.order : ''
        this.temporalOrderBy = (this.queryVivemas.sortBy) ? selectOrder.id : ''
        /* Ruteo */
        let router = { name: this.routeName }
        router.query =  { sortBy: this.queryVivemas.sortBy, order: this.queryVivemas.order } 
        Object.entries(this.queryVivemas)
        .filter(([key, val]) => {
          if (val) { router.query[key] = val || ''}
          else { delete router.query[key] }
        })
        /* Ruteo */
        // console.log('clickOrderByBenefit: ', selectOrder)
        // gtm
        this.gtmFiltraryOrdenar('Ordenar por', 'Seleccionar filtro', selectOrder.name)
        this.getBenefitsCallback()
        this.pageTitle = this.generateTitle(this.queryVivemas);
        this.$router.push(router).catch(err => { console.log(err) })
        this.openPopupOrdenar = false
      },
      gtmFiltraryOrdenar (action, ctaString, value) {
        // console.log('gtmFiltraryOrdenar: ', action, ctaString,value )
        // GA4
        this.$gtm.trackEvent({
          'event': 'select_radio_button',
          'Nombre Sección':  'Zona Segura',
          'TipoElemento': 'Radio Button',
          'TipoAccion': action,
          // 'TipoAccion': 'Ordenar por', // Filtrar por
          'CTA': ctaString + ' - ' + value,
        });
        // UA
        // this.$gtm.trackEvent({
        //   'event': 'virtualEvent',
        //   'category': 'Zona Segura',
        //   'action': action,
        //   'label': ctaString + ' - ' + value,
        // });
      },
      clear () {
        this.queryVivemas.city = ''
        this.queryVivemas.product = ''
        this.queryVivemas.benefit_type = ''
        let router = { name: this.routeName, query: {} }
        Object.entries(this.queryVivemas)
        .filter(([key, value]) => {
          if (value) { router.query[key] = value }
        })
        this.getBenefitsCallback()
        this.$router.push(router).catch(err => { console.log(err) })
        this.pageTitle = this.generateTitle(router.query || {});
        this.openPopupFilter = !this.openPopupFilter
  
      },
      filterAction () {
        if ( this.queryVivemas.product) {
          this.gtmFiltraryOrdenar('Filtrar por', 'Seleccionar producto', this.queryVivemas.product)
          this.setFilters('product', this.queryVivemas.product, false)
        }
        if ( this.queryVivemas.city) {
          this.gtmFiltraryOrdenar('Filtrar por', 'Seleccionar ciudad', this.queryVivemas.city)
          this.setFilters('city', this.queryVivemas.city, false)
        }
        this.openPopupFilter = !this.openPopupFilter
  
      }
    },
    computed: {
      ...mapGetters('vivemas', ['benefitCategories', 'benefits', 'tracking']),
      ...mapGetters('user', ['basicInfo'])
    },
    created () {
      let products = localStorage.getItem('products')
      if (products && products !== null) {
        this.productsArray = JSON.parse(products).map(p => p.toLowerCase())
        this.isOnlySoat = this.productsArray.length === 1 && this.productsArray.includes('soat')
      }
    },
    
  }
  </script>
  <style>
    @import url('../assets/css/general.css');
    @import url('../assets/css/vivemas.css');
  
    article.g-flex.g-align-center {
        margin-left: 30px;
    }
  
    .list-category h3 {
      color: #535D66;
      margin-bottom: 25px;
      margin-top: -10px;
    }
  
    .v-tooltip__content {
      background: #454A6C;
    }
  
    .modal-detalle-item-content .g-flex p a {
      font-size: 14px;
    }
  
    .flex-container {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    }
  
    .space-between {
      justify-content: space-between;
    }
  
    .selected-box {
      border-color: #0855c4 !important;
    }
  
    .selected-box-modal {
      /*
      border-color: #0855c4 !important;
      border: 1px solid;
      */
      width: 125px !important;
      margin-left: 30px !important;
      height: 165px;
      border-radius: 10px;
    }
    .selected-box-modal figure {
      border: 1px solid #0855c4 !important;
    }
    span.title_back_solicitudes {
      font-weight: 500;
    }
  
    @media screen and (max-width: 768px) {
      .modal-content-data {
        height: 30rem;
        overflow: auto
      }
  
      .modal-detalle-content .col-1 {
          padding-top: 20px;
      }
  
      article.g-flex.g-align-center {
        margin-left: 0px;
      }
    }
  
    @media only screen and (max-width: 400px) {
      .modal-content-data {
        height: 28rem;
        overflow: auto
      }
    }
    .img-viajes-formatter > img{
      position: relative;
      left: -1em;
    }
  
    .figcaption-viajes-formatter{
      position: relative;
      left: -1em;
    }
  
    .img-ver-mas-formatter > img{
      display: block;
      position: relative;
      left: -1em;
    }
  
    .figcaption-ver-mas-formatter{
      position: relative;
      left: -0.5em;
    }
  </style>
  



// WEBPACK FOOTER //
// src/pages/LandingBenefits.vue